import React from 'react'
import { Row, Col } from 'react-bootstrap'


export default function Leistungen() {



    return (
        <>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/1.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/2.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/3.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/5.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/6.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/4.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/10.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/8.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/9.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/7.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/11.jpg")} />
            </Col>
            <Col className="px-4" xs={6} lg={4}>
                <img className="py-4 img-fluid" src={require("../media/galerie/12.jpg")} />
            </Col>

        </>
    )
}